export const STAGE = [
  {
    btnText: "Foundational Talent",
    title: "Build your first critical team members.",
    subliner:
      "When making high-impact critical foundational hires, Devise is your search partner.",
    list: [
      "Founding leadership",
      "Early engineering, GTM, operations",
      "Recruiting strategy & hiring process guidance",
    ],
    footer: ["Early Stage", "Cost-effective model with limited commitment"],
  },
  {
    btnText: "Hiring Partnership",
    title: "Scale departments and leadership teams.",
    subliner:
      "When building teams across multiple functions, Devise is your embedded hiring partner.",
    list: [
      "Driving recruiting success",
      "Process optimization",
      "Recruiting infrastructure",
    ],
    footer: ["Growth Stage", "Monthly hiring partnership designed for scale"],
  },
  {
    btnText: "Targeted Search",
    title: "Support and strengthen internal recruiting function.",
    subliner:
      "When hiring becomes an operational function, Devise is your talent acquisition extension that delivers on key hires.",
    list: [
      "Specialized talent",
      "Managers & functional leaders",
      "Confidential searches",
    ],
    footer: ["Enterprise Stage", "Trusted by high-growth teams"],
  },
];
